import { ROUTES as APP_ROUTES } from '@core/routes'

export const ROUTES = {
    home: APP_ROUTES.home,
    subscriptions: APP_ROUTES.subscriptions,
    signIn: APP_ROUTES.signIn,
    signUp: APP_ROUTES.signUp,
    audacityDownload: '/download/audacity',
    feed: '/feed',
    genres: APP_ROUTES.genres,
    soundEffects: '/content/sound-effects',
    catalog: '/search',
    toolTranscription: APP_ROUTES.toolTranscription,
    toolAudioConverter: APP_ROUTES.toolAudioConverter,
    toolMp3Cutter: APP_ROUTES.toolMp3Cutter,
    toolVideoToMp3: APP_ROUTES.toolVideoToMp3,
    toolVocalRemover: APP_ROUTES.toolVocalRemover,
    toolStemSplitter: APP_ROUTES.toolStemSplitter,
    toolVoiceExtractor: APP_ROUTES.toolVoiceExtractor,
    toolInstrumentalExtractor: APP_ROUTES.toolInstrumentalExtractor,
    fanSupport: APP_ROUTES.fanSupport,
    promoPages: APP_ROUTES.promoPages,
    insights: APP_ROUTES.insights,
    apiLanding: APP_ROUTES.apiLanding,
    settings: '/profile',
} as const
